declare let THREE: any;

export class ConnectionPoint extends (THREE.Mesh as { new(geometry, material): any; }) {

  constructor(prevLineId: number | undefined, currentLineId: number | undefined) {
    const geometry = new THREE.SphereBufferGeometry(5, 32, 32);
    const material = new THREE.MeshBasicMaterial({color: 0x000000});
    super(geometry, material);
    this.userData.prevLineId = prevLineId;
    this.userData.currentLineId = currentLineId;
    this.visible = false;
  }

  get prevLineId(): number | undefined {
    return this.userData.prevLineId;
  }

  get currentLineId(): number | undefined {
    return this.userData.currentLineId;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/ConnectionPoint.ts